import { useMutation } from "@apollo/react-hooks";
import { Card, Page } from "@shopify/polaris";
import React, { useCallback } from "react";

import { useAppContext } from "../../context";
import { CREATE_AMAZON_IDEA } from "../../graphql/mutations/amazon-idea";
import { getParamByRole, handleError } from "../../helper";
import history from "../../history";
import useTimeout from "../../hooks/useTimeout";
import { useToastContext } from "../shared/ToastContext";
import AmazonIdeaForm from "./amazon-idea-form";

export default function CreateAmazonIdeaPage() {
    const { currentUser } = useAppContext();
    const pathname = getParamByRole(currentUser);

    const { setNotify, toggleToast } = useToastContext();

    const [setDelay] = useTimeout();
    const [createAmazonIdea, { loading }] = useMutation(CREATE_AMAZON_IDEA, {
        onCompleted: () => {
            setNotify({ msg: "Create amazon idea successfully", err: false });

            setDelay(() => {
                history.push(`/${pathname}/amazon-ideas`);
            }, 1000);
        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    const handleSubmit = useCallback(
        (input) => {
            if (!input) return;

            toggleToast && toggleToast(true);
            setNotify && setNotify({ msg: null, err: false });
            createAmazonIdea({
                variables: {
                    input,
                },
            });
        },
        [createAmazonIdea, setNotify, toggleToast],
    );

    return (
        <Page
            title="Create Amazon Idea"
            breadcrumbs={[
                { content: "Amazon Ideas", url: `/${pathname}/amazon-ideas` },
            ]}
            fullWidth
        >
            <Card sectioned>
                <AmazonIdeaForm onSubmit={handleSubmit} loading={loading} />
            </Card>
        </Page>
    );
}
